import { render, staticRenderFns } from "./GlobalStats.vue?vue&type=template&id=64e3073a&scoped=true"
import script from "./GlobalStats.vue?vue&type=script&lang=js"
export * from "./GlobalStats.vue?vue&type=script&lang=js"
import style0 from "./GlobalStats.vue?vue&type=style&index=0&id=64e3073a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3073a",
  null
  
)

export default component.exports